(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('@babel/runtime/helpers/slicedToArray'), require('@babel/runtime/helpers/classCallCheck'), require('@babel/runtime/helpers/createClass'), require('@rsksmart/rbank-utils'), require('lodash')) :
  typeof define === 'function' && define.amd ? define(['@babel/runtime/helpers/slicedToArray', '@babel/runtime/helpers/classCallCheck', '@babel/runtime/helpers/createClass', '@rsksmart/rbank-utils', 'lodash'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['rbank-controller'] = factory(global._slicedToArray, global._classCallCheck, global._createClass, global.rbankUtils, global._));
}(this, (function (_slicedToArray, _classCallCheck, _createClass, rbankUtils, _) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
  var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
  var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
  var ___default = /*#__PURE__*/_interopDefaultLegacy(_);

  var contractName = "Controller";
  var abi = [
  	{
  		inputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "constructor"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "MANTISSA",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "collateralFactor",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "deployBlock",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "liquidationFactor",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		name: "marketList",
  		outputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		name: "markets",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		name: "marketsByToken",
  		outputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "owner",
  		outputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		name: "prices",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "marketListSize",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "factor",
  				type: "uint256"
  			}
  		],
  		name: "setCollateralFactor",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "factor",
  				type: "uint256"
  			}
  		],
  		name: "setLiquidationFactor",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "market",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "price",
  				type: "uint256"
  			}
  		],
  		name: "setPrice",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "market",
  				type: "address"
  			}
  		],
  		name: "addMarket",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "account",
  				type: "address"
  			}
  		],
  		name: "getAccountLiquidity",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "account",
  				type: "address"
  			}
  		],
  		name: "getAccountHealth",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "account",
  				type: "address"
  			}
  		],
  		name: "getAccountValues",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "supplyValue",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "borrowValue",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "borrower",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "liquidator",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			},
  			{
  				internalType: "contract MarketInterface",
  				name: "collateralMarket",
  				type: "address"
  			}
  		],
  		name: "liquidateCollateral",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "collateralAmount",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	}
  ];
  var metadata = "{\"compiler\":{\"version\":\"0.5.16+commit.9c3226ce\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"constant\":true,\"inputs\":[],\"name\":\"MANTISSA\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"market\",\"type\":\"address\"}],\"name\":\"addMarket\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"collateralFactor\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"deployBlock\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"account\",\"type\":\"address\"}],\"name\":\"getAccountHealth\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"account\",\"type\":\"address\"}],\"name\":\"getAccountLiquidity\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"account\",\"type\":\"address\"}],\"name\":\"getAccountValues\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"supplyValue\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"borrowValue\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"borrower\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"liquidator\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"},{\"internalType\":\"contract MarketInterface\",\"name\":\"collateralMarket\",\"type\":\"address\"}],\"name\":\"liquidateCollateral\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"collateralAmount\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"liquidationFactor\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"name\":\"marketList\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"marketListSize\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"name\":\"markets\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"name\":\"marketsByToken\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"name\":\"prices\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"factor\",\"type\":\"uint256\"}],\"name\":\"setCollateralFactor\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"factor\",\"type\":\"uint256\"}],\"name\":\"setLiquidationFactor\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"market\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"price\",\"type\":\"uint256\"}],\"name\":\"setPrice\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"devdoc\":{\"methods\":{}},\"userdoc\":{\"methods\":{}}},\"settings\":{\"compilationTarget\":{\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Controller.sol\":\"Controller\"},\"evmVersion\":\"istanbul\",\"libraries\":{},\"optimizer\":{\"enabled\":false,\"runs\":200},\"remappings\":[]},\"sources\":{\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Controller.sol\":{\"keccak256\":\"0x7a986783350abcbf9337b2ecc2dbf6e501b66856963b2440b6dc4f6be2e1f19a\",\"urls\":[\"bzz-raw://a68c2bb147c6f511a2e053769fe0783aa04b28d994515e8cfb9a33b281d269af\",\"dweb:/ipfs/QmeCmC5XYdHfdNyNvR3wHrFwaLkm9a2czxDPYWMzasXK4p\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/MarketInterface.sol\":{\"keccak256\":\"0x14c49e26afee92737bfb10d9da5b0e064b4bf2adedf3dbb6a5c73c1914ef98f0\",\"urls\":[\"bzz-raw://f3d76e3cc0c62c31030c4c09b0eec1274e61a3dc76c47cdff9882a6b7f77c5f7\",\"dweb:/ipfs/QmZyGzmFQjRn2UyYFWmPLimWBDgBkGVW8V1WxP5kPm3RMJ\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/SafeMath.sol\":{\"keccak256\":\"0xa83f091bb99c1f412f78ceb5ca5a23f8adc2fdf0f20d730ac5de3ed99609d08a\",\"urls\":[\"bzz-raw://3d8d04982ebb23c75e529ae3fab2c0e53d7ffccf6b90308219f232f578bbc9b5\",\"dweb:/ipfs/QmeZ8TeKWfYHgZ1H5d5uWzjwVwFsC4E2sbBDxy96XWabJr\"]}},\"version\":1}";
  var bytecode = "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";
  var deployedBytecode = "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";
  var sourceMap = "96:3986:0:-;;;504:92;8:9:-1;5:2;;;30:1;27;20:12;5:2;504:92:0;543:10;535:5;;:18;;;;;;;;;;;;;;;;;;577:12;563:11;:26;;;;96:3986;;;;;;";
  var deployedSourceMap = "96:3986:0:-;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;96:3986:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1083:137;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1083:137:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;330:27;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;330:27:0;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;433:35;;;:::i;:::-;;;;;;;;;;;;;;;;;;;398:29;;;:::i;:::-;;;;;;;;;;;;;;;;;;;2625:464;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2625:464:0;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;3095:985;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;3095:985:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;769:92;;;:::i;:::-;;;;;;;;;;;;;;;;;;;1525:468;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1525:468:0;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;974:103;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;974:103:0;;;;;;;;;;;;;;;;;:::i;:::-;;155:20;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;182:40;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;182:40:0;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;1226:293;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1226:293:0;;;;;;;;;;;;;;;;;;;:::i;:::-;;474:23;;;:::i;:::-;;;;;;;;;;;;;;;;;;;867:101;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;867:101:0;;;;;;;;;;;;;;;;;:::i;:::-;;284:39;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;284:39:0;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;364:28;;;:::i;:::-;;;;;;;;;;;;;;;;;;;228:50;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;228:50:0;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;1999:258;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1999:258:0;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;1083:137;655:5;;;;;;;;;;;641:19;;:10;:19;;;633:28;;;;;;1164:7;:15;1172:6;1164:15;;;;;;;;;;;;;;;;;;;;;;;;;1156:24;;;;;;1208:5;1191:6;:14;1198:6;1191:14;;;;;;;;;;;;;;;:22;;;;1083:137;;:::o;330:27::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;433:35::-;465:3;433:35;:::o;398:29::-;;;;:::o;2625:464::-;2689:16;2707;2740:6;2749:1;2740:10;;2735:348;2756:10;:17;;;;2752:1;:21;2735:348;;;2794:22;2835:10;2846:1;2835:13;;;;;;;;;;;;;;;;;;;;;;;;;2794:55;;2863:10;2876:6;:21;2883:10;2894:1;2883:13;;;;;;;;;;;;;;;;;;;;;;;;;2876:21;;;;;;;;;;;;;;;;2863:34;;2926:59;2942:42;2978:5;2942:6;:22;;;2965:7;2942:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2942:31:0;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;2942:31:0;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2942:31:0;;;;;;;;;;;;;;;;:35;;:42;;;;:::i;:::-;2926:11;:15;;:59;;;;:::i;:::-;2912:73;;3013:59;3029:42;3065:5;3029:6;:22;;;3052:7;3029:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3029:31:0;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;3029:31:0;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;3029:31:0;;;;;;;;;;;;;;;;:35;;:42;;;;:::i;:::-;3013:11;:15;;:59;;;;:::i;:::-;2999:73;;2735:348;;2775:3;;;;;;;2735:348;;;;2625:464;;;:::o;3095:985::-;3236:21;725:7;:19;733:10;725:19;;;;;;;;;;;;;;;;;;;;;;;;;717:28;;;;;;3270:10;3283:6;:18;3290:10;3283:18;;;;;;;;;;;;;;;;3270:31;;3327:1;3319:5;:9;3311:18;;;;;;3340:20;3363:6;:33;3378:16;3363:33;;;;;;;;;;;;;;;;3340:56;;3432:1;3414:15;:19;3406:28;;;;;;3445:16;3471;3527:26;3544:8;3527:16;:26::i;:::-;3498:55;;;;;;;;3585:1;3571:11;:15;3563:24;;;;;;3598:16;3617:46;3638:11;3651;3617:20;:46::i;:::-;3598:65;;465:3;3682:11;:23;;3674:32;;;;;;3717:21;3741:17;3752:5;3741:6;:10;;:17;;;;:::i;:::-;3717:41;;3768:26;3797:47;3832:11;3797:30;465:3;3797:16;:20;;:30;;;;:::i;:::-;:34;;:47;;;;:::i;:::-;3768:76;;3854:20;3877:52;465:3;3877:38;3893:21;3877:11;:15;;:38;;;;:::i;:::-;:42;;:52;;;;:::i;:::-;3854:75;;3959:36;3979:15;3959;:19;;:36;;;;:::i;:::-;3940:55;;4006:16;:27;;;4034:8;4044:10;4056:16;4006:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4006:67:0;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;4006:67:0;;;;755:1;;;;;;;;3095:985;;;;;;:::o;769:92::-;816:4;837:10;:17;;;;830:24;;769:92;:::o;1525:468::-;1592:4;1608:14;1625:1;1608:18;;1637:16;1663;1719:25;1736:7;1719:16;:25::i;:::-;1690:54;;;;;;;;1769:47;1785:30;465:3;1785:16;;:20;;:30;;;;:::i;:::-;1769:11;:15;;:47;;;;:::i;:::-;1755:61;;1840:25;465:3;1840:11;:15;;:25;;;;:::i;:::-;1826:39;;1894:11;1880;:25;1876:83;;;1931:28;1947:11;1931;:15;;:28;;;;:::i;:::-;1919:40;;1876:83;1977:9;1970:16;;;;;1525:468;;;:::o;974:103::-;655:5;;;;;;;;;;;641:19;;:10;:19;;;633:28;;;;;;1064:6;1044:17;:26;;;;974:103;:::o;155:20::-;;;;;;;;;;;;;:::o;182:40::-;;;;;;;;;;;;;;;;;;;;;;:::o;1226:293::-;655:5;;;;;;;;;;;641:19;;:10;:19;;;633:28;;;;;;1288:19;1326:6;1310:29;;;:31;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1310:31:0;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;1310:31:0;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1310:31:0;;;;;;;;;;;;;;;;1288:53;;1398:1;1359:41;;:14;:27;1374:11;1359:27;;;;;;;;;;;;;;;;;;;;;;;;;:41;;;1351:50;;;;;;1429:4;1411:7;:15;1419:6;1411:15;;;;;;;;;;;;;;;;:22;;;;;;;;;;;;;;;;;;1473:6;1443:14;:27;1458:11;1443:27;;;;;;;;;;;;;;;;:36;;;;;;;;;;;;;;;;;;1489:10;1505:6;1489:23;;39:1:-1;33:3;27:10;23:18;57:10;52:3;45:23;79:10;72:17;;0:93;1489:23:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;671:1;1226:293;:::o;474:23::-;;;;:::o;867:101::-;655:5;;;;;;;;;;;641:19;;:10;:19;;;633:28;;;;;;955:6;936:16;:25;;;;867:101;:::o;284:39::-;;;;;;;;;;;;;;;;;:::o;364:28::-;;;;:::o;228:50::-;;;;;;;;;;;;;;;;;;;;;;:::o;1999:258::-;2063:4;2079:16;2105;2161:25;2178:7;2161:16;:25::i;:::-;2132:54;;;;;;;;2204:46;2225:11;2238;2204:20;:46::i;:::-;2197:53;;;;1999:258;;;:::o;211:413:8:-;269:9;516:1;511;:6;507:45;;;540:1;533:8;;;;507:45;570:1;566;:5;562:9;;597:1;592;588;:5;;;;;;:10;581:18;;;;616:1;609:8;;211:413;;;;;:::o;1314:137::-;1372:9;1401:1;1397;:5;1393:9;;1424:1;1419;:6;;1412:14;;;;1443:1;1436:8;;1314:137;;;;:::o;2263:356:0:-;2352:4;2387:1;2372:11;:16;:36;;;;2407:1;2392:11;:16;2372:36;2368:62;;;2429:1;2422:8;;;;2368:62;2455:48;2471:31;465:3;2471:17;;:21;;:31;;;;:::i;:::-;2455:11;:15;;:48;;;;:::i;:::-;2441:62;;2527:25;465:3;2527:11;:15;;:25;;;;:::i;:::-;2513:39;;2570:42;2600:11;2570:25;465:3;2570:11;:15;;:25;;;;:::i;:::-;:29;;:42;;;;:::i;:::-;2563:49;;2263:356;;;;;:::o;714:290:8:-;772:7;996:1;992;:5;;;;;;985:12;;714:290;;;;:::o;1124:120::-;1182:7;1213:1;1208;:6;;1201:14;;;;1236:1;1232;:5;1225:12;;1124:120;;;;:::o";
  var source = "pragma solidity >=0.5.0 <0.6.0;\n\nimport \"./MarketInterface.sol\";\nimport \"./test/SafeMath.sol\";\n\ncontract Controller {\n    using SafeMath for uint256;\n\n    address public owner;\n\n    mapping (address => bool) public markets;\n    mapping (address => address) public marketsByToken;\n    mapping (address => uint) public prices;\n\n    address[] public marketList;\n\n    uint public collateralFactor;\n    uint public liquidationFactor;\n    uint public constant MANTISSA = 1e6;\n    uint public deployBlock;\n\n    constructor() public {\n        owner = msg.sender;\n        deployBlock = block.number;\n    }\n\n    modifier onlyOwner() {\n        require(msg.sender == owner);\n        _;\n    }\n\n    modifier onlyMarket() {\n        require(markets[msg.sender]);\n        _;\n    }\n\n    function marketListSize() public view returns (uint) {\n      return marketList.length;\n    }\n\n    function setCollateralFactor(uint factor) public onlyOwner {\n        collateralFactor = factor;\n    }\n\n    function setLiquidationFactor(uint factor) public onlyOwner {\n        liquidationFactor = factor;\n    }\n\n    function setPrice(address market, uint price) public onlyOwner {\n        require(markets[market]);\n\n        prices[market] = price;\n    }\n\n    function addMarket(address market) public onlyOwner {\n        address marketToken = MarketInterface(market).token();\n        require(marketsByToken[marketToken] == address(0));\n        markets[market] = true;\n        marketsByToken[marketToken] = market;\n        marketList.push(market);\n    }\n\n    function getAccountLiquidity(address account) public view returns (uint) {\n        uint liquidity = 0;\n\n        uint supplyValue;\n        uint borrowValue;\n\n        (supplyValue, borrowValue) = getAccountValues(account);\n\n        borrowValue = borrowValue.mul(collateralFactor.add(MANTISSA));\n        borrowValue = borrowValue.div(MANTISSA);\n\n        if (borrowValue < supplyValue)\n            liquidity = supplyValue.sub(borrowValue);\n\n        return liquidity;\n    }\n\n    function getAccountHealth(address account) public view returns (uint) {\n        uint supplyValue;\n        uint borrowValue;\n\n        (supplyValue, borrowValue) = getAccountValues(account);\n\n        return calculateHealthIndex(supplyValue, borrowValue);\n    }\n\n    function calculateHealthIndex(uint supplyValue, uint borrowValue) internal view returns (uint) {\n        if (supplyValue == 0 || borrowValue == 0)\n            return 0;\n\n        borrowValue = borrowValue.mul(liquidationFactor.add(MANTISSA));\n        borrowValue = borrowValue.div(MANTISSA);\n\n        return supplyValue.mul(MANTISSA).div(borrowValue);\n    }\n\n    function getAccountValues(address account) public view returns (uint supplyValue, uint borrowValue) {\n        for (uint k = 0; k < marketList.length; k++) {\n            MarketInterface market = MarketInterface(marketList[k]);\n            uint price = prices[marketList[k]];\n\n            supplyValue = supplyValue.add(market.updatedSupplyOf(account).mul(price));\n            borrowValue = borrowValue.add(market.updatedBorrowBy(account).mul(price));\n        }\n    }\n\n    function liquidateCollateral(address borrower, address liquidator, uint amount, MarketInterface collateralMarket) public onlyMarket returns (uint collateralAmount)  {\n        uint price = prices[msg.sender];\n        require(price > 0);\n\n        uint collateralPrice = prices[address(collateralMarket)];\n        require(collateralPrice > 0);\n\n        uint supplyValue;\n        uint borrowValue;\n\n        (supplyValue, borrowValue) = getAccountValues(borrower);\n        require(borrowValue > 0);\n\n        uint healthIndex = calculateHealthIndex(supplyValue, borrowValue);\n\n        require(healthIndex <= MANTISSA);\n\n        uint liquidationValue = amount.mul(price);\n        uint liquidationPercentage = liquidationValue.mul(MANTISSA).div(borrowValue);\n        uint collateralValue = supplyValue.mul(liquidationPercentage).div(MANTISSA);\n\n        collateralAmount = collateralValue.div(collateralPrice);\n\n        collateralMarket.transferTo(borrower, liquidator, collateralAmount);\n    }\n}\n\n";
  var sourcePath = "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Controller.sol";
  var ast = {
  	absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Controller.sol",
  	exportedSymbols: {
  		Controller: [
  			479
  		]
  	},
  	id: 480,
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 1,
  			literals: [
  				"solidity",
  				">=",
  				"0.5",
  				".0",
  				"<",
  				"0.6",
  				".0"
  			],
  			nodeType: "PragmaDirective",
  			src: "0:31:0"
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/MarketInterface.sol",
  			file: "./MarketInterface.sol",
  			id: 2,
  			nodeType: "ImportDirective",
  			scope: 480,
  			sourceUnit: 1825,
  			src: "33:31:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/SafeMath.sol",
  			file: "./test/SafeMath.sol",
  			id: 3,
  			nodeType: "ImportDirective",
  			scope: 480,
  			sourceUnit: 2170,
  			src: "65:29:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			baseContracts: [
  			],
  			contractDependencies: [
  			],
  			contractKind: "contract",
  			documentation: null,
  			fullyImplemented: true,
  			id: 479,
  			linearizedBaseContracts: [
  				479
  			],
  			name: "Controller",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					id: 6,
  					libraryName: {
  						contractScope: null,
  						id: 4,
  						name: "SafeMath",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2169,
  						src: "128:8:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SafeMath_$2169",
  							typeString: "library SafeMath"
  						}
  					},
  					nodeType: "UsingForDirective",
  					src: "122:27:0",
  					typeName: {
  						id: 5,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "141:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					}
  				},
  				{
  					constant: false,
  					id: 8,
  					name: "owner",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "155:20:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_address",
  						typeString: "address"
  					},
  					typeName: {
  						id: 7,
  						name: "address",
  						nodeType: "ElementaryTypeName",
  						src: "155:7:0",
  						stateMutability: "nonpayable",
  						typeDescriptions: {
  							typeIdentifier: "t_address",
  							typeString: "address"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 12,
  					name: "markets",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "182:40:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  						typeString: "mapping(address => bool)"
  					},
  					typeName: {
  						id: 11,
  						keyType: {
  							id: 9,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "191:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "182:25:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  							typeString: "mapping(address => bool)"
  						},
  						valueType: {
  							id: 10,
  							name: "bool",
  							nodeType: "ElementaryTypeName",
  							src: "202:4:0",
  							typeDescriptions: {
  								typeIdentifier: "t_bool",
  								typeString: "bool"
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 16,
  					name: "marketsByToken",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "228:50:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  						typeString: "mapping(address => address)"
  					},
  					typeName: {
  						id: 15,
  						keyType: {
  							id: 13,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "237:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "228:28:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  							typeString: "mapping(address => address)"
  						},
  						valueType: {
  							id: 14,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "248:7:0",
  							stateMutability: "nonpayable",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 20,
  					name: "prices",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "284:39:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  						typeString: "mapping(address => uint256)"
  					},
  					typeName: {
  						id: 19,
  						keyType: {
  							id: 17,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "293:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "284:25:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  							typeString: "mapping(address => uint256)"
  						},
  						valueType: {
  							id: 18,
  							name: "uint",
  							nodeType: "ElementaryTypeName",
  							src: "304:4:0",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 23,
  					name: "marketList",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "330:27:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_array$_t_address_$dyn_storage",
  						typeString: "address[]"
  					},
  					typeName: {
  						baseType: {
  							id: 21,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "330:7:0",
  							stateMutability: "nonpayable",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						id: 22,
  						length: null,
  						nodeType: "ArrayTypeName",
  						src: "330:9:0",
  						typeDescriptions: {
  							typeIdentifier: "t_array$_t_address_$dyn_storage_ptr",
  							typeString: "address[]"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 25,
  					name: "collateralFactor",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "364:28:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 24,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "364:4:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 27,
  					name: "liquidationFactor",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "398:29:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 26,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "398:4:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: true,
  					id: 30,
  					name: "MANTISSA",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "433:35:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 28,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "433:4:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "316536",
  						id: 29,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "465:3:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_1000000_by_1",
  							typeString: "int_const 1000000"
  						},
  						value: "1e6"
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 32,
  					name: "deployBlock",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "474:23:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 31,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "474:4:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 45,
  						nodeType: "Block",
  						src: "525:71:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 38,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 35,
  										name: "owner",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 8,
  										src: "535:5:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 36,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2431,
  											src: "543:3:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 37,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "543:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "535:18:0",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								id: 39,
  								nodeType: "ExpressionStatement",
  								src: "535:18:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 43,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 40,
  										name: "deployBlock",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 32,
  										src: "563:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 41,
  											name: "block",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2421,
  											src: "577:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_block",
  												typeString: "block"
  											}
  										},
  										id: 42,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "number",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "577:12:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "563:26:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 44,
  								nodeType: "ExpressionStatement",
  								src: "563:26:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 46,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 33,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "515:2:0"
  					},
  					returnParameters: {
  						id: 34,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "525:0:0"
  					},
  					scope: 479,
  					src: "504:92:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 56,
  						nodeType: "Block",
  						src: "623:56:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 52,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 49,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "641:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 50,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "641:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												id: 51,
  												name: "owner",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 8,
  												src: "655:5:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											src: "641:19:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 48,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "633:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 53,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "633:28:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 54,
  								nodeType: "ExpressionStatement",
  								src: "633:28:0"
  							},
  							{
  								id: 55,
  								nodeType: "PlaceholderStatement",
  								src: "671:1:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 57,
  					name: "onlyOwner",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 47,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "620:2:0"
  					},
  					src: "602:77:0",
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 67,
  						nodeType: "Block",
  						src: "707:56:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 60,
  												name: "markets",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 12,
  												src: "725:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  													typeString: "mapping(address => bool)"
  												}
  											},
  											id: 63,
  											indexExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 61,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "733:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 62,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "733:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "725:19:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 59,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "717:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 64,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "717:28:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 65,
  								nodeType: "ExpressionStatement",
  								src: "717:28:0"
  							},
  							{
  								id: 66,
  								nodeType: "PlaceholderStatement",
  								src: "755:1:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 68,
  					name: "onlyMarket",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 58,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "704:2:0"
  					},
  					src: "685:78:0",
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 76,
  						nodeType: "Block",
  						src: "822:39:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									expression: {
  										argumentTypes: null,
  										id: 73,
  										name: "marketList",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 23,
  										src: "837:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_array$_t_address_$dyn_storage",
  											typeString: "address[] storage ref"
  										}
  									},
  									id: 74,
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									memberName: "length",
  									nodeType: "MemberAccess",
  									referencedDeclaration: null,
  									src: "837:17:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 72,
  								id: 75,
  								nodeType: "Return",
  								src: "830:24:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 77,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "marketListSize",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 69,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "792:2:0"
  					},
  					returnParameters: {
  						id: 72,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 71,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 77,
  								src: "816:4:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 70,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "816:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "815:6:0"
  					},
  					scope: 479,
  					src: "769:92:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 88,
  						nodeType: "Block",
  						src: "926:42:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 86,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 84,
  										name: "collateralFactor",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 25,
  										src: "936:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 85,
  										name: "factor",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 79,
  										src: "955:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "936:25:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 87,
  								nodeType: "ExpressionStatement",
  								src: "936:25:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 89,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 82,
  							modifierName: {
  								argumentTypes: null,
  								id: 81,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 57,
  								src: "916:9:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "916:9:0"
  						}
  					],
  					name: "setCollateralFactor",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 80,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 79,
  								name: "factor",
  								nodeType: "VariableDeclaration",
  								scope: 89,
  								src: "896:11:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 78,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "896:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "895:13:0"
  					},
  					returnParameters: {
  						id: 83,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "926:0:0"
  					},
  					scope: 479,
  					src: "867:101:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 100,
  						nodeType: "Block",
  						src: "1034:43:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 98,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 96,
  										name: "liquidationFactor",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 27,
  										src: "1044:17:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 97,
  										name: "factor",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 91,
  										src: "1064:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1044:26:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 99,
  								nodeType: "ExpressionStatement",
  								src: "1044:26:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 101,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 94,
  							modifierName: {
  								argumentTypes: null,
  								id: 93,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 57,
  								src: "1024:9:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "1024:9:0"
  						}
  					],
  					name: "setLiquidationFactor",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 92,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 91,
  								name: "factor",
  								nodeType: "VariableDeclaration",
  								scope: 101,
  								src: "1004:11:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 90,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1004:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1003:13:0"
  					},
  					returnParameters: {
  						id: 95,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1034:0:0"
  					},
  					scope: 479,
  					src: "974:103:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 122,
  						nodeType: "Block",
  						src: "1146:74:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 111,
  												name: "markets",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 12,
  												src: "1164:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  													typeString: "mapping(address => bool)"
  												}
  											},
  											id: 113,
  											indexExpression: {
  												argumentTypes: null,
  												id: 112,
  												name: "market",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 103,
  												src: "1172:6:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "1164:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 110,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1156:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 114,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1156:24:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 115,
  								nodeType: "ExpressionStatement",
  								src: "1156:24:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 120,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 116,
  											name: "prices",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 20,
  											src: "1191:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  												typeString: "mapping(address => uint256)"
  											}
  										},
  										id: 118,
  										indexExpression: {
  											argumentTypes: null,
  											id: 117,
  											name: "market",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 103,
  											src: "1198:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "1191:14:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 119,
  										name: "price",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 105,
  										src: "1208:5:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1191:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 121,
  								nodeType: "ExpressionStatement",
  								src: "1191:22:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 123,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 108,
  							modifierName: {
  								argumentTypes: null,
  								id: 107,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 57,
  								src: "1136:9:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "1136:9:0"
  						}
  					],
  					name: "setPrice",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 106,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 103,
  								name: "market",
  								nodeType: "VariableDeclaration",
  								scope: 123,
  								src: "1101:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 102,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1101:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 105,
  								name: "price",
  								nodeType: "VariableDeclaration",
  								scope: 123,
  								src: "1117:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 104,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1117:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1100:28:0"
  					},
  					returnParameters: {
  						id: 109,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1146:0:0"
  					},
  					scope: 479,
  					src: "1083:137:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 166,
  						nodeType: "Block",
  						src: "1278:241:0",
  						statements: [
  							{
  								assignments: [
  									131
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 131,
  										name: "marketToken",
  										nodeType: "VariableDeclaration",
  										scope: 166,
  										src: "1288:19:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										typeName: {
  											id: 130,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "1288:7:0",
  											stateMutability: "nonpayable",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 137,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 133,
  													name: "market",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 125,
  													src: "1326:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												],
  												id: 132,
  												name: "MarketInterface",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1824,
  												src: "1310:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_contract$_MarketInterface_$1824_$",
  													typeString: "type(contract MarketInterface)"
  												}
  											},
  											id: 134,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "1310:23:0",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										},
  										id: 135,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "token",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1783,
  										src: "1310:29:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$__$returns$_t_address_$",
  											typeString: "function () view external returns (address)"
  										}
  									},
  									id: 136,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1310:31:0",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "1288:53:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 145,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												baseExpression: {
  													argumentTypes: null,
  													id: 139,
  													name: "marketsByToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 16,
  													src: "1359:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  														typeString: "mapping(address => address)"
  													}
  												},
  												id: 141,
  												indexExpression: {
  													argumentTypes: null,
  													id: 140,
  													name: "marketToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 131,
  													src: "1374:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "1359:27:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														hexValue: "30",
  														id: 143,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "1398:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														}
  													],
  													id: 142,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "1390:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: "address"
  												},
  												id: 144,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1390:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "1359:41:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 138,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1351:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 146,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1351:50:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 147,
  								nodeType: "ExpressionStatement",
  								src: "1351:50:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 152,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 148,
  											name: "markets",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 12,
  											src: "1411:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  												typeString: "mapping(address => bool)"
  											}
  										},
  										id: 150,
  										indexExpression: {
  											argumentTypes: null,
  											id: 149,
  											name: "market",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 125,
  											src: "1419:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "1411:15:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										hexValue: "74727565",
  										id: 151,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "bool",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "1429:4:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										},
  										value: "true"
  									},
  									src: "1411:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 153,
  								nodeType: "ExpressionStatement",
  								src: "1411:22:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 158,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 154,
  											name: "marketsByToken",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 16,
  											src: "1443:14:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  												typeString: "mapping(address => address)"
  											}
  										},
  										id: 156,
  										indexExpression: {
  											argumentTypes: null,
  											id: 155,
  											name: "marketToken",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 131,
  											src: "1458:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "1443:27:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 157,
  										name: "market",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 125,
  										src: "1473:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									src: "1443:36:0",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								id: 159,
  								nodeType: "ExpressionStatement",
  								src: "1443:36:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 163,
  											name: "market",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 125,
  											src: "1505:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 160,
  											name: "marketList",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 23,
  											src: "1489:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_array$_t_address_$dyn_storage",
  												typeString: "address[] storage ref"
  											}
  										},
  										id: 162,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "push",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "1489:15:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_arraypush_nonpayable$_t_address_$returns$_t_uint256_$",
  											typeString: "function (address) returns (uint256)"
  										}
  									},
  									id: 164,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1489:23:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 165,
  								nodeType: "ExpressionStatement",
  								src: "1489:23:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 167,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 128,
  							modifierName: {
  								argumentTypes: null,
  								id: 127,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 57,
  								src: "1268:9:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "1268:9:0"
  						}
  					],
  					name: "addMarket",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 126,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 125,
  								name: "market",
  								nodeType: "VariableDeclaration",
  								scope: 167,
  								src: "1245:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 124,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1245:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1244:16:0"
  					},
  					returnParameters: {
  						id: 129,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1278:0:0"
  					},
  					scope: 479,
  					src: "1226:293:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 222,
  						nodeType: "Block",
  						src: "1598:395:0",
  						statements: [
  							{
  								assignments: [
  									175
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 175,
  										name: "liquidity",
  										nodeType: "VariableDeclaration",
  										scope: 222,
  										src: "1608:14:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 174,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "1608:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 177,
  								initialValue: {
  									argumentTypes: null,
  									hexValue: "30",
  									id: 176,
  									isConstant: false,
  									isLValue: false,
  									isPure: true,
  									kind: "number",
  									lValueRequested: false,
  									nodeType: "Literal",
  									src: "1625:1:0",
  									subdenomination: null,
  									typeDescriptions: {
  										typeIdentifier: "t_rational_0_by_1",
  										typeString: "int_const 0"
  									},
  									value: "0"
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "1608:18:0"
  							},
  							{
  								assignments: [
  									179
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 179,
  										name: "supplyValue",
  										nodeType: "VariableDeclaration",
  										scope: 222,
  										src: "1637:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 178,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "1637:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 180,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "1637:16:0"
  							},
  							{
  								assignments: [
  									182
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 182,
  										name: "borrowValue",
  										nodeType: "VariableDeclaration",
  										scope: 222,
  										src: "1663:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 181,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "1663:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 183,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "1663:16:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 190,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 184,
  												name: "supplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 179,
  												src: "1691:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 185,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 182,
  												src: "1704:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 186,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "1690:26:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 188,
  												name: "account",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 169,
  												src: "1736:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 187,
  											name: "getAccountValues",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 360,
  											src: "1719:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address) view returns (uint256,uint256)"
  											}
  										},
  										id: 189,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1719:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "1690:54:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 191,
  								nodeType: "ExpressionStatement",
  								src: "1690:54:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 200,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 192,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 182,
  										src: "1755:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 197,
  														name: "MANTISSA",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 30,
  														src: "1806:8:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 195,
  														name: "collateralFactor",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 25,
  														src: "1785:16:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 196,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "add",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2168,
  													src: "1785:20:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 198,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1785:30:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 193,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 182,
  												src: "1769:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 194,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "mul",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2110,
  											src: "1769:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 199,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1769:47:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1755:61:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 201,
  								nodeType: "ExpressionStatement",
  								src: "1755:61:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 207,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 202,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 182,
  										src: "1826:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 205,
  												name: "MANTISSA",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 30,
  												src: "1856:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 203,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 182,
  												src: "1840:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 204,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "1840:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 206,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1840:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1826:39:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 208,
  								nodeType: "ExpressionStatement",
  								src: "1826:39:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 211,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 209,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 182,
  										src: "1880:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										argumentTypes: null,
  										id: 210,
  										name: "supplyValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 179,
  										src: "1894:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1880:25:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 219,
  								nodeType: "IfStatement",
  								src: "1876:83:0",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										id: 217,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftHandSide: {
  											argumentTypes: null,
  											id: 212,
  											name: "liquidity",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 175,
  											src: "1919:9:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "Assignment",
  										operator: "=",
  										rightHandSide: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 215,
  													name: "borrowValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 182,
  													src: "1947:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 213,
  													name: "supplyValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 179,
  													src: "1931:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 214,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sub",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2144,
  												src: "1931:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 216,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "1931:28:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										src: "1919:40:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 218,
  									nodeType: "ExpressionStatement",
  									src: "1919:40:0"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 220,
  									name: "liquidity",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 175,
  									src: "1977:9:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 173,
  								id: 221,
  								nodeType: "Return",
  								src: "1970:16:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 223,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getAccountLiquidity",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 170,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 169,
  								name: "account",
  								nodeType: "VariableDeclaration",
  								scope: 223,
  								src: "1554:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 168,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1554:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1553:17:0"
  					},
  					returnParameters: {
  						id: 173,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 172,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 223,
  								src: "1592:4:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 171,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1592:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1591:6:0"
  					},
  					scope: 479,
  					src: "1525:468:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 249,
  						nodeType: "Block",
  						src: "2069:188:0",
  						statements: [
  							{
  								assignments: [
  									231
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 231,
  										name: "supplyValue",
  										nodeType: "VariableDeclaration",
  										scope: 249,
  										src: "2079:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 230,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "2079:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 232,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "2079:16:0"
  							},
  							{
  								assignments: [
  									234
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 234,
  										name: "borrowValue",
  										nodeType: "VariableDeclaration",
  										scope: 249,
  										src: "2105:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 233,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "2105:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 235,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "2105:16:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 242,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 236,
  												name: "supplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 231,
  												src: "2133:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 237,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 234,
  												src: "2146:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 238,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "2132:26:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 240,
  												name: "account",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 225,
  												src: "2178:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 239,
  											name: "getAccountValues",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 360,
  											src: "2161:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address) view returns (uint256,uint256)"
  											}
  										},
  										id: 241,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "2161:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "2132:54:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 243,
  								nodeType: "ExpressionStatement",
  								src: "2132:54:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 245,
  											name: "supplyValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 231,
  											src: "2225:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 246,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 234,
  											src: "2238:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 244,
  										name: "calculateHealthIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 295,
  										src: "2204:20:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 247,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2204:46:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 229,
  								id: 248,
  								nodeType: "Return",
  								src: "2197:53:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 250,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getAccountHealth",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 226,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 225,
  								name: "account",
  								nodeType: "VariableDeclaration",
  								scope: 250,
  								src: "2025:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 224,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "2025:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2024:17:0"
  					},
  					returnParameters: {
  						id: 229,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 228,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 250,
  								src: "2063:4:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 227,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2063:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2062:6:0"
  					},
  					scope: 479,
  					src: "1999:258:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 294,
  						nodeType: "Block",
  						src: "2358:261:0",
  						statements: [
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									},
  									id: 265,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										commonType: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										id: 261,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftExpression: {
  											argumentTypes: null,
  											id: 259,
  											name: "supplyValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 252,
  											src: "2372:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "BinaryOperation",
  										operator: "==",
  										rightExpression: {
  											argumentTypes: null,
  											hexValue: "30",
  											id: 260,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "2387:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										},
  										src: "2372:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "||",
  									rightExpression: {
  										argumentTypes: null,
  										commonType: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										id: 264,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftExpression: {
  											argumentTypes: null,
  											id: 262,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 254,
  											src: "2392:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "BinaryOperation",
  										operator: "==",
  										rightExpression: {
  											argumentTypes: null,
  											hexValue: "30",
  											id: 263,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "2407:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										},
  										src: "2392:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									src: "2372:36:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 268,
  								nodeType: "IfStatement",
  								src: "2368:62:0",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 266,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2429:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 258,
  									id: 267,
  									nodeType: "Return",
  									src: "2422:8:0"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 277,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 269,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 254,
  										src: "2441:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 274,
  														name: "MANTISSA",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 30,
  														src: "2493:8:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 272,
  														name: "liquidationFactor",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 27,
  														src: "2471:17:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 273,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "add",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2168,
  													src: "2471:21:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 275,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "2471:31:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 270,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 254,
  												src: "2455:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 271,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "mul",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2110,
  											src: "2455:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 276,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "2455:48:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2441:62:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 278,
  								nodeType: "ExpressionStatement",
  								src: "2441:62:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 284,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 279,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 254,
  										src: "2513:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 282,
  												name: "MANTISSA",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 30,
  												src: "2543:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 280,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 254,
  												src: "2527:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 281,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "2527:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 283,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "2527:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2513:39:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 285,
  								nodeType: "ExpressionStatement",
  								src: "2513:39:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 291,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 254,
  											src: "2600:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 288,
  													name: "MANTISSA",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 30,
  													src: "2586:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 286,
  													name: "supplyValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 252,
  													src: "2570:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 287,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "2570:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 289,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2570:25:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 290,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "2570:29:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 292,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2570:42:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 258,
  								id: 293,
  								nodeType: "Return",
  								src: "2563:49:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 295,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "calculateHealthIndex",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 255,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 252,
  								name: "supplyValue",
  								nodeType: "VariableDeclaration",
  								scope: 295,
  								src: "2293:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 251,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2293:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 254,
  								name: "borrowValue",
  								nodeType: "VariableDeclaration",
  								scope: 295,
  								src: "2311:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 253,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2311:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2292:36:0"
  					},
  					returnParameters: {
  						id: 258,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 257,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 295,
  								src: "2352:4:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 256,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2352:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2351:6:0"
  					},
  					scope: 479,
  					src: "2263:356:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 359,
  						nodeType: "Block",
  						src: "2725:364:0",
  						statements: [
  							{
  								body: {
  									id: 357,
  									nodeType: "Block",
  									src: "2780:303:0",
  									statements: [
  										{
  											assignments: [
  												316
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 316,
  													name: "market",
  													nodeType: "VariableDeclaration",
  													scope: 357,
  													src: "2794:22:0",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_MarketInterface_$1824",
  														typeString: "contract MarketInterface"
  													},
  													typeName: {
  														contractScope: null,
  														id: 315,
  														name: "MarketInterface",
  														nodeType: "UserDefinedTypeName",
  														referencedDeclaration: 1824,
  														src: "2794:15:0",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_MarketInterface_$1824",
  															typeString: "contract MarketInterface"
  														}
  													},
  													value: null,
  													visibility: "internal"
  												}
  											],
  											id: 322,
  											initialValue: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														baseExpression: {
  															argumentTypes: null,
  															id: 318,
  															name: "marketList",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 23,
  															src: "2835:10:0",
  															typeDescriptions: {
  																typeIdentifier: "t_array$_t_address_$dyn_storage",
  																typeString: "address[] storage ref"
  															}
  														},
  														id: 320,
  														indexExpression: {
  															argumentTypes: null,
  															id: 319,
  															name: "k",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 305,
  															src: "2846:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "2835:13:0",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													id: 317,
  													name: "MarketInterface",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1824,
  													src: "2819:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_contract$_MarketInterface_$1824_$",
  														typeString: "type(contract MarketInterface)"
  													}
  												},
  												id: 321,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "2819:30:0",
  												typeDescriptions: {
  													typeIdentifier: "t_contract$_MarketInterface_$1824",
  													typeString: "contract MarketInterface"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "2794:55:0"
  										},
  										{
  											assignments: [
  												324
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 324,
  													name: "price",
  													nodeType: "VariableDeclaration",
  													scope: 357,
  													src: "2863:10:0",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													typeName: {
  														id: 323,
  														name: "uint",
  														nodeType: "ElementaryTypeName",
  														src: "2863:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													value: null,
  													visibility: "internal"
  												}
  											],
  											id: 330,
  											initialValue: {
  												argumentTypes: null,
  												baseExpression: {
  													argumentTypes: null,
  													id: 325,
  													name: "prices",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 20,
  													src: "2876:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  														typeString: "mapping(address => uint256)"
  													}
  												},
  												id: 329,
  												indexExpression: {
  													argumentTypes: null,
  													baseExpression: {
  														argumentTypes: null,
  														id: 326,
  														name: "marketList",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 23,
  														src: "2883:10:0",
  														typeDescriptions: {
  															typeIdentifier: "t_array$_t_address_$dyn_storage",
  															typeString: "address[] storage ref"
  														}
  													},
  													id: 328,
  													indexExpression: {
  														argumentTypes: null,
  														id: 327,
  														name: "k",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 305,
  														src: "2894:1:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "2883:13:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "2876:21:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "2863:34:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 342,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 331,
  													name: "supplyValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 300,
  													src: "2912:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 339,
  																	name: "price",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 324,
  																	src: "2978:5:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	argumentTypes: null,
  																	"arguments": [
  																		{
  																			argumentTypes: null,
  																			id: 336,
  																			name: "account",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 297,
  																			src: "2965:7:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		}
  																	],
  																	expression: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: null,
  																			id: 334,
  																			name: "market",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 316,
  																			src: "2942:6:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_contract$_MarketInterface_$1824",
  																				typeString: "contract MarketInterface"
  																			}
  																		},
  																		id: 335,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "updatedSupplyOf",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: 1804,
  																		src: "2942:22:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  																			typeString: "function (address) view external returns (uint256)"
  																		}
  																	},
  																	id: 337,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	kind: "functionCall",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "2942:31:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 338,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "mul",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 2110,
  																src: "2942:35:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 340,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "2942:42:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 332,
  															name: "supplyValue",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 300,
  															src: "2926:11:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 333,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2168,
  														src: "2926:15:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 341,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "2926:59:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "2912:73:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 343,
  											nodeType: "ExpressionStatement",
  											src: "2912:73:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 355,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 344,
  													name: "borrowValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 302,
  													src: "2999:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 352,
  																	name: "price",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 324,
  																	src: "3065:5:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	argumentTypes: null,
  																	"arguments": [
  																		{
  																			argumentTypes: null,
  																			id: 349,
  																			name: "account",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 297,
  																			src: "3052:7:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		}
  																	],
  																	expression: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: null,
  																			id: 347,
  																			name: "market",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 316,
  																			src: "3029:6:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_contract$_MarketInterface_$1824",
  																				typeString: "contract MarketInterface"
  																			}
  																		},
  																		id: 348,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "updatedBorrowBy",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: 1811,
  																		src: "3029:22:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  																			typeString: "function (address) view external returns (uint256)"
  																		}
  																	},
  																	id: 350,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	kind: "functionCall",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "3029:31:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 351,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "mul",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 2110,
  																src: "3029:35:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 353,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "3029:42:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 345,
  															name: "borrowValue",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 302,
  															src: "3013:11:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 346,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2168,
  														src: "3013:15:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 354,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "3013:59:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "2999:73:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 356,
  											nodeType: "ExpressionStatement",
  											src: "2999:73:0"
  										}
  									]
  								},
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 311,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 308,
  										name: "k",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 305,
  										src: "2752:1:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 309,
  											name: "marketList",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 23,
  											src: "2756:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_array$_t_address_$dyn_storage",
  												typeString: "address[] storage ref"
  											}
  										},
  										id: 310,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "length",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "2756:17:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2752:21:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 358,
  								initializationExpression: {
  									assignments: [
  										305
  									],
  									declarations: [
  										{
  											constant: false,
  											id: 305,
  											name: "k",
  											nodeType: "VariableDeclaration",
  											scope: 358,
  											src: "2740:6:0",
  											stateVariable: false,
  											storageLocation: "default",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											typeName: {
  												id: 304,
  												name: "uint",
  												nodeType: "ElementaryTypeName",
  												src: "2740:4:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											value: null,
  											visibility: "internal"
  										}
  									],
  									id: 307,
  									initialValue: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 306,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2749:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									nodeType: "VariableDeclarationStatement",
  									src: "2740:10:0"
  								},
  								loopExpression: {
  									expression: {
  										argumentTypes: null,
  										id: 313,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "UnaryOperation",
  										operator: "++",
  										prefix: false,
  										src: "2775:3:0",
  										subExpression: {
  											argumentTypes: null,
  											id: 312,
  											name: "k",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 305,
  											src: "2775:1:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 314,
  									nodeType: "ExpressionStatement",
  									src: "2775:3:0"
  								},
  								nodeType: "ForStatement",
  								src: "2735:348:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 360,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getAccountValues",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 298,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 297,
  								name: "account",
  								nodeType: "VariableDeclaration",
  								scope: 360,
  								src: "2651:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 296,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "2651:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2650:17:0"
  					},
  					returnParameters: {
  						id: 303,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 300,
  								name: "supplyValue",
  								nodeType: "VariableDeclaration",
  								scope: 360,
  								src: "2689:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 299,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2689:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 302,
  								name: "borrowValue",
  								nodeType: "VariableDeclaration",
  								scope: 360,
  								src: "2707:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 301,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2707:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2688:36:0"
  					},
  					scope: 479,
  					src: "2625:464:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 477,
  						nodeType: "Block",
  						src: "3260:820:0",
  						statements: [
  							{
  								assignments: [
  									376
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 376,
  										name: "price",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3270:10:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 375,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3270:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 381,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 377,
  										name: "prices",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 20,
  										src: "3283:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  											typeString: "mapping(address => uint256)"
  										}
  									},
  									id: 380,
  									indexExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 378,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2431,
  											src: "3290:3:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 379,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "3290:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "3283:18:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3270:31:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 385,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 383,
  												name: "price",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 376,
  												src: "3319:5:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 384,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3327:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "3319:9:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 382,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "3311:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 386,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3311:18:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 387,
  								nodeType: "ExpressionStatement",
  								src: "3311:18:0"
  							},
  							{
  								assignments: [
  									389
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 389,
  										name: "collateralPrice",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3340:20:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 388,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3340:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 395,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 390,
  										name: "prices",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 20,
  										src: "3363:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  											typeString: "mapping(address => uint256)"
  										}
  									},
  									id: 394,
  									indexExpression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 392,
  												name: "collateralMarket",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 368,
  												src: "3378:16:0",
  												typeDescriptions: {
  													typeIdentifier: "t_contract$_MarketInterface_$1824",
  													typeString: "contract MarketInterface"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_contract$_MarketInterface_$1824",
  													typeString: "contract MarketInterface"
  												}
  											],
  											id: 391,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											lValueRequested: false,
  											nodeType: "ElementaryTypeNameExpression",
  											src: "3370:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_type$_t_address_$",
  												typeString: "type(address)"
  											},
  											typeName: "address"
  										},
  										id: 393,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "typeConversion",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3370:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "3363:33:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3340:56:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 399,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 397,
  												name: "collateralPrice",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 389,
  												src: "3414:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 398,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3432:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "3414:19:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 396,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "3406:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 400,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3406:28:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 401,
  								nodeType: "ExpressionStatement",
  								src: "3406:28:0"
  							},
  							{
  								assignments: [
  									403
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 403,
  										name: "supplyValue",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3445:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 402,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3445:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 404,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3445:16:0"
  							},
  							{
  								assignments: [
  									406
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 406,
  										name: "borrowValue",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3471:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 405,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3471:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 407,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3471:16:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 414,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 408,
  												name: "supplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 403,
  												src: "3499:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 409,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 406,
  												src: "3512:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 410,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "3498:26:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 412,
  												name: "borrower",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 362,
  												src: "3544:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 411,
  											name: "getAccountValues",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 360,
  											src: "3527:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address) view returns (uint256,uint256)"
  											}
  										},
  										id: 413,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3527:26:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "3498:55:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 415,
  								nodeType: "ExpressionStatement",
  								src: "3498:55:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 419,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 417,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 406,
  												src: "3571:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 418,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3585:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "3571:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 416,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "3563:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 420,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3563:24:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 421,
  								nodeType: "ExpressionStatement",
  								src: "3563:24:0"
  							},
  							{
  								assignments: [
  									423
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 423,
  										name: "healthIndex",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3598:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 422,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3598:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 428,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 425,
  											name: "supplyValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 403,
  											src: "3638:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 426,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 406,
  											src: "3651:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 424,
  										name: "calculateHealthIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 295,
  										src: "3617:20:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 427,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3617:46:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3598:65:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 432,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 430,
  												name: "healthIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 423,
  												src: "3682:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "<=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 431,
  												name: "MANTISSA",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 30,
  												src: "3697:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "3682:23:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 429,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "3674:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 433,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3674:32:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 434,
  								nodeType: "ExpressionStatement",
  								src: "3674:32:0"
  							},
  							{
  								assignments: [
  									436
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 436,
  										name: "liquidationValue",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3717:21:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 435,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3717:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 441,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 439,
  											name: "price",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 376,
  											src: "3752:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 437,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 366,
  											src: "3741:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 438,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "mul",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2110,
  										src: "3741:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 440,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3741:17:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3717:41:0"
  							},
  							{
  								assignments: [
  									443
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 443,
  										name: "liquidationPercentage",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3768:26:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 442,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3768:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 451,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 449,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 406,
  											src: "3832:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 446,
  													name: "MANTISSA",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 30,
  													src: "3818:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 444,
  													name: "liquidationValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 436,
  													src: "3797:16:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 445,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "3797:20:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 447,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3797:30:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 448,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "3797:34:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 450,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3797:47:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3768:76:0"
  							},
  							{
  								assignments: [
  									453
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 453,
  										name: "collateralValue",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3854:20:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 452,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3854:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 461,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 459,
  											name: "MANTISSA",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 30,
  											src: "3920:8:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 456,
  													name: "liquidationPercentage",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 443,
  													src: "3893:21:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 454,
  													name: "supplyValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 403,
  													src: "3877:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 455,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "3877:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 457,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3877:38:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 458,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "3877:42:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 460,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3877:52:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3854:75:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 467,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 462,
  										name: "collateralAmount",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 373,
  										src: "3940:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 465,
  												name: "collateralPrice",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 389,
  												src: "3979:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 463,
  												name: "collateralValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 453,
  												src: "3959:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 464,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "3959:19:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 466,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3959:36:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "3940:55:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 468,
  								nodeType: "ExpressionStatement",
  								src: "3940:55:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 472,
  											name: "borrower",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 362,
  											src: "4034:8:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 473,
  											name: "liquidator",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 364,
  											src: "4044:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 474,
  											name: "collateralAmount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 373,
  											src: "4056:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 469,
  											name: "collateralMarket",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 368,
  											src: "4006:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										},
  										id: 471,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "transferTo",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1823,
  										src: "4006:27:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256) external"
  										}
  									},
  									id: 475,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4006:67:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 476,
  								nodeType: "ExpressionStatement",
  								src: "4006:67:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 478,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 371,
  							modifierName: {
  								argumentTypes: null,
  								id: 370,
  								name: "onlyMarket",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 68,
  								src: "3216:10:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "3216:10:0"
  						}
  					],
  					name: "liquidateCollateral",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 369,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 362,
  								name: "borrower",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3124:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 361,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3124:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 364,
  								name: "liquidator",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3142:18:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 363,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3142:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 366,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3162:11:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 365,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3162:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 368,
  								name: "collateralMarket",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3175:32:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_contract$_MarketInterface_$1824",
  									typeString: "contract MarketInterface"
  								},
  								typeName: {
  									contractScope: null,
  									id: 367,
  									name: "MarketInterface",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1824,
  									src: "3175:15:0",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_MarketInterface_$1824",
  										typeString: "contract MarketInterface"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3123:85:0"
  					},
  					returnParameters: {
  						id: 374,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 373,
  								name: "collateralAmount",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3236:21:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 372,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3236:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3235:23:0"
  					},
  					scope: 479,
  					src: "3095:985:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				}
  			],
  			scope: 480,
  			src: "96:3986:0"
  		}
  	],
  	src: "0:4084:0"
  };
  var legacyAST = {
  	absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Controller.sol",
  	exportedSymbols: {
  		Controller: [
  			479
  		]
  	},
  	id: 480,
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 1,
  			literals: [
  				"solidity",
  				">=",
  				"0.5",
  				".0",
  				"<",
  				"0.6",
  				".0"
  			],
  			nodeType: "PragmaDirective",
  			src: "0:31:0"
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/MarketInterface.sol",
  			file: "./MarketInterface.sol",
  			id: 2,
  			nodeType: "ImportDirective",
  			scope: 480,
  			sourceUnit: 1825,
  			src: "33:31:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/SafeMath.sol",
  			file: "./test/SafeMath.sol",
  			id: 3,
  			nodeType: "ImportDirective",
  			scope: 480,
  			sourceUnit: 2170,
  			src: "65:29:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			baseContracts: [
  			],
  			contractDependencies: [
  			],
  			contractKind: "contract",
  			documentation: null,
  			fullyImplemented: true,
  			id: 479,
  			linearizedBaseContracts: [
  				479
  			],
  			name: "Controller",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					id: 6,
  					libraryName: {
  						contractScope: null,
  						id: 4,
  						name: "SafeMath",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2169,
  						src: "128:8:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SafeMath_$2169",
  							typeString: "library SafeMath"
  						}
  					},
  					nodeType: "UsingForDirective",
  					src: "122:27:0",
  					typeName: {
  						id: 5,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "141:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					}
  				},
  				{
  					constant: false,
  					id: 8,
  					name: "owner",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "155:20:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_address",
  						typeString: "address"
  					},
  					typeName: {
  						id: 7,
  						name: "address",
  						nodeType: "ElementaryTypeName",
  						src: "155:7:0",
  						stateMutability: "nonpayable",
  						typeDescriptions: {
  							typeIdentifier: "t_address",
  							typeString: "address"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 12,
  					name: "markets",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "182:40:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  						typeString: "mapping(address => bool)"
  					},
  					typeName: {
  						id: 11,
  						keyType: {
  							id: 9,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "191:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "182:25:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  							typeString: "mapping(address => bool)"
  						},
  						valueType: {
  							id: 10,
  							name: "bool",
  							nodeType: "ElementaryTypeName",
  							src: "202:4:0",
  							typeDescriptions: {
  								typeIdentifier: "t_bool",
  								typeString: "bool"
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 16,
  					name: "marketsByToken",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "228:50:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  						typeString: "mapping(address => address)"
  					},
  					typeName: {
  						id: 15,
  						keyType: {
  							id: 13,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "237:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "228:28:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  							typeString: "mapping(address => address)"
  						},
  						valueType: {
  							id: 14,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "248:7:0",
  							stateMutability: "nonpayable",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 20,
  					name: "prices",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "284:39:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  						typeString: "mapping(address => uint256)"
  					},
  					typeName: {
  						id: 19,
  						keyType: {
  							id: 17,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "293:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "284:25:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  							typeString: "mapping(address => uint256)"
  						},
  						valueType: {
  							id: 18,
  							name: "uint",
  							nodeType: "ElementaryTypeName",
  							src: "304:4:0",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 23,
  					name: "marketList",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "330:27:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_array$_t_address_$dyn_storage",
  						typeString: "address[]"
  					},
  					typeName: {
  						baseType: {
  							id: 21,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "330:7:0",
  							stateMutability: "nonpayable",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						id: 22,
  						length: null,
  						nodeType: "ArrayTypeName",
  						src: "330:9:0",
  						typeDescriptions: {
  							typeIdentifier: "t_array$_t_address_$dyn_storage_ptr",
  							typeString: "address[]"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 25,
  					name: "collateralFactor",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "364:28:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 24,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "364:4:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 27,
  					name: "liquidationFactor",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "398:29:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 26,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "398:4:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: true,
  					id: 30,
  					name: "MANTISSA",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "433:35:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 28,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "433:4:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "316536",
  						id: 29,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "465:3:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_1000000_by_1",
  							typeString: "int_const 1000000"
  						},
  						value: "1e6"
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 32,
  					name: "deployBlock",
  					nodeType: "VariableDeclaration",
  					scope: 479,
  					src: "474:23:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 31,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "474:4:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 45,
  						nodeType: "Block",
  						src: "525:71:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 38,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 35,
  										name: "owner",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 8,
  										src: "535:5:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 36,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2431,
  											src: "543:3:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 37,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "543:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "535:18:0",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								id: 39,
  								nodeType: "ExpressionStatement",
  								src: "535:18:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 43,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 40,
  										name: "deployBlock",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 32,
  										src: "563:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 41,
  											name: "block",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2421,
  											src: "577:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_block",
  												typeString: "block"
  											}
  										},
  										id: 42,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "number",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "577:12:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "563:26:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 44,
  								nodeType: "ExpressionStatement",
  								src: "563:26:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 46,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 33,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "515:2:0"
  					},
  					returnParameters: {
  						id: 34,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "525:0:0"
  					},
  					scope: 479,
  					src: "504:92:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 56,
  						nodeType: "Block",
  						src: "623:56:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 52,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 49,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "641:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 50,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "641:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												id: 51,
  												name: "owner",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 8,
  												src: "655:5:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											src: "641:19:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 48,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "633:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 53,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "633:28:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 54,
  								nodeType: "ExpressionStatement",
  								src: "633:28:0"
  							},
  							{
  								id: 55,
  								nodeType: "PlaceholderStatement",
  								src: "671:1:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 57,
  					name: "onlyOwner",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 47,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "620:2:0"
  					},
  					src: "602:77:0",
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 67,
  						nodeType: "Block",
  						src: "707:56:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 60,
  												name: "markets",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 12,
  												src: "725:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  													typeString: "mapping(address => bool)"
  												}
  											},
  											id: 63,
  											indexExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 61,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "733:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 62,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "733:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "725:19:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 59,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "717:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 64,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "717:28:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 65,
  								nodeType: "ExpressionStatement",
  								src: "717:28:0"
  							},
  							{
  								id: 66,
  								nodeType: "PlaceholderStatement",
  								src: "755:1:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 68,
  					name: "onlyMarket",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 58,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "704:2:0"
  					},
  					src: "685:78:0",
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 76,
  						nodeType: "Block",
  						src: "822:39:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									expression: {
  										argumentTypes: null,
  										id: 73,
  										name: "marketList",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 23,
  										src: "837:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_array$_t_address_$dyn_storage",
  											typeString: "address[] storage ref"
  										}
  									},
  									id: 74,
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									memberName: "length",
  									nodeType: "MemberAccess",
  									referencedDeclaration: null,
  									src: "837:17:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 72,
  								id: 75,
  								nodeType: "Return",
  								src: "830:24:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 77,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "marketListSize",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 69,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "792:2:0"
  					},
  					returnParameters: {
  						id: 72,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 71,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 77,
  								src: "816:4:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 70,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "816:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "815:6:0"
  					},
  					scope: 479,
  					src: "769:92:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 88,
  						nodeType: "Block",
  						src: "926:42:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 86,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 84,
  										name: "collateralFactor",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 25,
  										src: "936:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 85,
  										name: "factor",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 79,
  										src: "955:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "936:25:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 87,
  								nodeType: "ExpressionStatement",
  								src: "936:25:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 89,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 82,
  							modifierName: {
  								argumentTypes: null,
  								id: 81,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 57,
  								src: "916:9:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "916:9:0"
  						}
  					],
  					name: "setCollateralFactor",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 80,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 79,
  								name: "factor",
  								nodeType: "VariableDeclaration",
  								scope: 89,
  								src: "896:11:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 78,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "896:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "895:13:0"
  					},
  					returnParameters: {
  						id: 83,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "926:0:0"
  					},
  					scope: 479,
  					src: "867:101:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 100,
  						nodeType: "Block",
  						src: "1034:43:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 98,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 96,
  										name: "liquidationFactor",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 27,
  										src: "1044:17:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 97,
  										name: "factor",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 91,
  										src: "1064:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1044:26:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 99,
  								nodeType: "ExpressionStatement",
  								src: "1044:26:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 101,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 94,
  							modifierName: {
  								argumentTypes: null,
  								id: 93,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 57,
  								src: "1024:9:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "1024:9:0"
  						}
  					],
  					name: "setLiquidationFactor",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 92,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 91,
  								name: "factor",
  								nodeType: "VariableDeclaration",
  								scope: 101,
  								src: "1004:11:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 90,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1004:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1003:13:0"
  					},
  					returnParameters: {
  						id: 95,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1034:0:0"
  					},
  					scope: 479,
  					src: "974:103:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 122,
  						nodeType: "Block",
  						src: "1146:74:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 111,
  												name: "markets",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 12,
  												src: "1164:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  													typeString: "mapping(address => bool)"
  												}
  											},
  											id: 113,
  											indexExpression: {
  												argumentTypes: null,
  												id: 112,
  												name: "market",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 103,
  												src: "1172:6:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "1164:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 110,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1156:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 114,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1156:24:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 115,
  								nodeType: "ExpressionStatement",
  								src: "1156:24:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 120,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 116,
  											name: "prices",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 20,
  											src: "1191:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  												typeString: "mapping(address => uint256)"
  											}
  										},
  										id: 118,
  										indexExpression: {
  											argumentTypes: null,
  											id: 117,
  											name: "market",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 103,
  											src: "1198:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "1191:14:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 119,
  										name: "price",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 105,
  										src: "1208:5:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1191:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 121,
  								nodeType: "ExpressionStatement",
  								src: "1191:22:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 123,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 108,
  							modifierName: {
  								argumentTypes: null,
  								id: 107,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 57,
  								src: "1136:9:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "1136:9:0"
  						}
  					],
  					name: "setPrice",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 106,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 103,
  								name: "market",
  								nodeType: "VariableDeclaration",
  								scope: 123,
  								src: "1101:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 102,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1101:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 105,
  								name: "price",
  								nodeType: "VariableDeclaration",
  								scope: 123,
  								src: "1117:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 104,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1117:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1100:28:0"
  					},
  					returnParameters: {
  						id: 109,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1146:0:0"
  					},
  					scope: 479,
  					src: "1083:137:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 166,
  						nodeType: "Block",
  						src: "1278:241:0",
  						statements: [
  							{
  								assignments: [
  									131
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 131,
  										name: "marketToken",
  										nodeType: "VariableDeclaration",
  										scope: 166,
  										src: "1288:19:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										typeName: {
  											id: 130,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "1288:7:0",
  											stateMutability: "nonpayable",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 137,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 133,
  													name: "market",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 125,
  													src: "1326:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												],
  												id: 132,
  												name: "MarketInterface",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1824,
  												src: "1310:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_contract$_MarketInterface_$1824_$",
  													typeString: "type(contract MarketInterface)"
  												}
  											},
  											id: 134,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "1310:23:0",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										},
  										id: 135,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "token",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1783,
  										src: "1310:29:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$__$returns$_t_address_$",
  											typeString: "function () view external returns (address)"
  										}
  									},
  									id: 136,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1310:31:0",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "1288:53:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 145,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												baseExpression: {
  													argumentTypes: null,
  													id: 139,
  													name: "marketsByToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 16,
  													src: "1359:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  														typeString: "mapping(address => address)"
  													}
  												},
  												id: 141,
  												indexExpression: {
  													argumentTypes: null,
  													id: 140,
  													name: "marketToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 131,
  													src: "1374:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "1359:27:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														hexValue: "30",
  														id: 143,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "1398:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														}
  													],
  													id: 142,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "1390:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: "address"
  												},
  												id: 144,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1390:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "1359:41:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 138,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1351:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 146,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1351:50:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 147,
  								nodeType: "ExpressionStatement",
  								src: "1351:50:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 152,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 148,
  											name: "markets",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 12,
  											src: "1411:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  												typeString: "mapping(address => bool)"
  											}
  										},
  										id: 150,
  										indexExpression: {
  											argumentTypes: null,
  											id: 149,
  											name: "market",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 125,
  											src: "1419:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "1411:15:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										hexValue: "74727565",
  										id: 151,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "bool",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "1429:4:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										},
  										value: "true"
  									},
  									src: "1411:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 153,
  								nodeType: "ExpressionStatement",
  								src: "1411:22:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 158,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 154,
  											name: "marketsByToken",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 16,
  											src: "1443:14:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  												typeString: "mapping(address => address)"
  											}
  										},
  										id: 156,
  										indexExpression: {
  											argumentTypes: null,
  											id: 155,
  											name: "marketToken",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 131,
  											src: "1458:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "1443:27:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 157,
  										name: "market",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 125,
  										src: "1473:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									src: "1443:36:0",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								id: 159,
  								nodeType: "ExpressionStatement",
  								src: "1443:36:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 163,
  											name: "market",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 125,
  											src: "1505:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 160,
  											name: "marketList",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 23,
  											src: "1489:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_array$_t_address_$dyn_storage",
  												typeString: "address[] storage ref"
  											}
  										},
  										id: 162,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "push",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "1489:15:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_arraypush_nonpayable$_t_address_$returns$_t_uint256_$",
  											typeString: "function (address) returns (uint256)"
  										}
  									},
  									id: 164,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1489:23:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 165,
  								nodeType: "ExpressionStatement",
  								src: "1489:23:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 167,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 128,
  							modifierName: {
  								argumentTypes: null,
  								id: 127,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 57,
  								src: "1268:9:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "1268:9:0"
  						}
  					],
  					name: "addMarket",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 126,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 125,
  								name: "market",
  								nodeType: "VariableDeclaration",
  								scope: 167,
  								src: "1245:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 124,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1245:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1244:16:0"
  					},
  					returnParameters: {
  						id: 129,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1278:0:0"
  					},
  					scope: 479,
  					src: "1226:293:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 222,
  						nodeType: "Block",
  						src: "1598:395:0",
  						statements: [
  							{
  								assignments: [
  									175
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 175,
  										name: "liquidity",
  										nodeType: "VariableDeclaration",
  										scope: 222,
  										src: "1608:14:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 174,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "1608:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 177,
  								initialValue: {
  									argumentTypes: null,
  									hexValue: "30",
  									id: 176,
  									isConstant: false,
  									isLValue: false,
  									isPure: true,
  									kind: "number",
  									lValueRequested: false,
  									nodeType: "Literal",
  									src: "1625:1:0",
  									subdenomination: null,
  									typeDescriptions: {
  										typeIdentifier: "t_rational_0_by_1",
  										typeString: "int_const 0"
  									},
  									value: "0"
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "1608:18:0"
  							},
  							{
  								assignments: [
  									179
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 179,
  										name: "supplyValue",
  										nodeType: "VariableDeclaration",
  										scope: 222,
  										src: "1637:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 178,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "1637:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 180,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "1637:16:0"
  							},
  							{
  								assignments: [
  									182
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 182,
  										name: "borrowValue",
  										nodeType: "VariableDeclaration",
  										scope: 222,
  										src: "1663:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 181,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "1663:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 183,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "1663:16:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 190,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 184,
  												name: "supplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 179,
  												src: "1691:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 185,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 182,
  												src: "1704:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 186,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "1690:26:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 188,
  												name: "account",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 169,
  												src: "1736:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 187,
  											name: "getAccountValues",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 360,
  											src: "1719:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address) view returns (uint256,uint256)"
  											}
  										},
  										id: 189,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1719:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "1690:54:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 191,
  								nodeType: "ExpressionStatement",
  								src: "1690:54:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 200,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 192,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 182,
  										src: "1755:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 197,
  														name: "MANTISSA",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 30,
  														src: "1806:8:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 195,
  														name: "collateralFactor",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 25,
  														src: "1785:16:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 196,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "add",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2168,
  													src: "1785:20:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 198,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1785:30:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 193,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 182,
  												src: "1769:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 194,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "mul",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2110,
  											src: "1769:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 199,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1769:47:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1755:61:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 201,
  								nodeType: "ExpressionStatement",
  								src: "1755:61:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 207,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 202,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 182,
  										src: "1826:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 205,
  												name: "MANTISSA",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 30,
  												src: "1856:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 203,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 182,
  												src: "1840:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 204,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "1840:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 206,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1840:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1826:39:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 208,
  								nodeType: "ExpressionStatement",
  								src: "1826:39:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 211,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 209,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 182,
  										src: "1880:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										argumentTypes: null,
  										id: 210,
  										name: "supplyValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 179,
  										src: "1894:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1880:25:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 219,
  								nodeType: "IfStatement",
  								src: "1876:83:0",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										id: 217,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftHandSide: {
  											argumentTypes: null,
  											id: 212,
  											name: "liquidity",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 175,
  											src: "1919:9:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "Assignment",
  										operator: "=",
  										rightHandSide: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 215,
  													name: "borrowValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 182,
  													src: "1947:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 213,
  													name: "supplyValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 179,
  													src: "1931:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 214,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sub",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2144,
  												src: "1931:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 216,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "1931:28:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										src: "1919:40:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 218,
  									nodeType: "ExpressionStatement",
  									src: "1919:40:0"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 220,
  									name: "liquidity",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 175,
  									src: "1977:9:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 173,
  								id: 221,
  								nodeType: "Return",
  								src: "1970:16:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 223,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getAccountLiquidity",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 170,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 169,
  								name: "account",
  								nodeType: "VariableDeclaration",
  								scope: 223,
  								src: "1554:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 168,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1554:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1553:17:0"
  					},
  					returnParameters: {
  						id: 173,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 172,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 223,
  								src: "1592:4:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 171,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1592:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1591:6:0"
  					},
  					scope: 479,
  					src: "1525:468:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 249,
  						nodeType: "Block",
  						src: "2069:188:0",
  						statements: [
  							{
  								assignments: [
  									231
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 231,
  										name: "supplyValue",
  										nodeType: "VariableDeclaration",
  										scope: 249,
  										src: "2079:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 230,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "2079:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 232,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "2079:16:0"
  							},
  							{
  								assignments: [
  									234
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 234,
  										name: "borrowValue",
  										nodeType: "VariableDeclaration",
  										scope: 249,
  										src: "2105:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 233,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "2105:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 235,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "2105:16:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 242,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 236,
  												name: "supplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 231,
  												src: "2133:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 237,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 234,
  												src: "2146:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 238,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "2132:26:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 240,
  												name: "account",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 225,
  												src: "2178:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 239,
  											name: "getAccountValues",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 360,
  											src: "2161:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address) view returns (uint256,uint256)"
  											}
  										},
  										id: 241,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "2161:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "2132:54:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 243,
  								nodeType: "ExpressionStatement",
  								src: "2132:54:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 245,
  											name: "supplyValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 231,
  											src: "2225:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 246,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 234,
  											src: "2238:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 244,
  										name: "calculateHealthIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 295,
  										src: "2204:20:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 247,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2204:46:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 229,
  								id: 248,
  								nodeType: "Return",
  								src: "2197:53:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 250,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getAccountHealth",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 226,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 225,
  								name: "account",
  								nodeType: "VariableDeclaration",
  								scope: 250,
  								src: "2025:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 224,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "2025:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2024:17:0"
  					},
  					returnParameters: {
  						id: 229,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 228,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 250,
  								src: "2063:4:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 227,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2063:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2062:6:0"
  					},
  					scope: 479,
  					src: "1999:258:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 294,
  						nodeType: "Block",
  						src: "2358:261:0",
  						statements: [
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									},
  									id: 265,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										commonType: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										id: 261,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftExpression: {
  											argumentTypes: null,
  											id: 259,
  											name: "supplyValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 252,
  											src: "2372:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "BinaryOperation",
  										operator: "==",
  										rightExpression: {
  											argumentTypes: null,
  											hexValue: "30",
  											id: 260,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "2387:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										},
  										src: "2372:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "||",
  									rightExpression: {
  										argumentTypes: null,
  										commonType: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										id: 264,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftExpression: {
  											argumentTypes: null,
  											id: 262,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 254,
  											src: "2392:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "BinaryOperation",
  										operator: "==",
  										rightExpression: {
  											argumentTypes: null,
  											hexValue: "30",
  											id: 263,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "2407:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										},
  										src: "2392:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									src: "2372:36:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 268,
  								nodeType: "IfStatement",
  								src: "2368:62:0",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 266,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2429:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 258,
  									id: 267,
  									nodeType: "Return",
  									src: "2422:8:0"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 277,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 269,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 254,
  										src: "2441:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 274,
  														name: "MANTISSA",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 30,
  														src: "2493:8:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 272,
  														name: "liquidationFactor",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 27,
  														src: "2471:17:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 273,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "add",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2168,
  													src: "2471:21:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 275,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "2471:31:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 270,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 254,
  												src: "2455:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 271,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "mul",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2110,
  											src: "2455:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 276,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "2455:48:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2441:62:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 278,
  								nodeType: "ExpressionStatement",
  								src: "2441:62:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 284,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 279,
  										name: "borrowValue",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 254,
  										src: "2513:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 282,
  												name: "MANTISSA",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 30,
  												src: "2543:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 280,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 254,
  												src: "2527:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 281,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "2527:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 283,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "2527:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2513:39:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 285,
  								nodeType: "ExpressionStatement",
  								src: "2513:39:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 291,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 254,
  											src: "2600:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 288,
  													name: "MANTISSA",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 30,
  													src: "2586:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 286,
  													name: "supplyValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 252,
  													src: "2570:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 287,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "2570:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 289,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2570:25:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 290,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "2570:29:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 292,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2570:42:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 258,
  								id: 293,
  								nodeType: "Return",
  								src: "2563:49:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 295,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "calculateHealthIndex",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 255,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 252,
  								name: "supplyValue",
  								nodeType: "VariableDeclaration",
  								scope: 295,
  								src: "2293:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 251,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2293:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 254,
  								name: "borrowValue",
  								nodeType: "VariableDeclaration",
  								scope: 295,
  								src: "2311:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 253,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2311:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2292:36:0"
  					},
  					returnParameters: {
  						id: 258,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 257,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 295,
  								src: "2352:4:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 256,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2352:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2351:6:0"
  					},
  					scope: 479,
  					src: "2263:356:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 359,
  						nodeType: "Block",
  						src: "2725:364:0",
  						statements: [
  							{
  								body: {
  									id: 357,
  									nodeType: "Block",
  									src: "2780:303:0",
  									statements: [
  										{
  											assignments: [
  												316
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 316,
  													name: "market",
  													nodeType: "VariableDeclaration",
  													scope: 357,
  													src: "2794:22:0",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_MarketInterface_$1824",
  														typeString: "contract MarketInterface"
  													},
  													typeName: {
  														contractScope: null,
  														id: 315,
  														name: "MarketInterface",
  														nodeType: "UserDefinedTypeName",
  														referencedDeclaration: 1824,
  														src: "2794:15:0",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_MarketInterface_$1824",
  															typeString: "contract MarketInterface"
  														}
  													},
  													value: null,
  													visibility: "internal"
  												}
  											],
  											id: 322,
  											initialValue: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														baseExpression: {
  															argumentTypes: null,
  															id: 318,
  															name: "marketList",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 23,
  															src: "2835:10:0",
  															typeDescriptions: {
  																typeIdentifier: "t_array$_t_address_$dyn_storage",
  																typeString: "address[] storage ref"
  															}
  														},
  														id: 320,
  														indexExpression: {
  															argumentTypes: null,
  															id: 319,
  															name: "k",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 305,
  															src: "2846:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "2835:13:0",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													id: 317,
  													name: "MarketInterface",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1824,
  													src: "2819:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_contract$_MarketInterface_$1824_$",
  														typeString: "type(contract MarketInterface)"
  													}
  												},
  												id: 321,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "2819:30:0",
  												typeDescriptions: {
  													typeIdentifier: "t_contract$_MarketInterface_$1824",
  													typeString: "contract MarketInterface"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "2794:55:0"
  										},
  										{
  											assignments: [
  												324
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 324,
  													name: "price",
  													nodeType: "VariableDeclaration",
  													scope: 357,
  													src: "2863:10:0",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													typeName: {
  														id: 323,
  														name: "uint",
  														nodeType: "ElementaryTypeName",
  														src: "2863:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													value: null,
  													visibility: "internal"
  												}
  											],
  											id: 330,
  											initialValue: {
  												argumentTypes: null,
  												baseExpression: {
  													argumentTypes: null,
  													id: 325,
  													name: "prices",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 20,
  													src: "2876:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  														typeString: "mapping(address => uint256)"
  													}
  												},
  												id: 329,
  												indexExpression: {
  													argumentTypes: null,
  													baseExpression: {
  														argumentTypes: null,
  														id: 326,
  														name: "marketList",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 23,
  														src: "2883:10:0",
  														typeDescriptions: {
  															typeIdentifier: "t_array$_t_address_$dyn_storage",
  															typeString: "address[] storage ref"
  														}
  													},
  													id: 328,
  													indexExpression: {
  														argumentTypes: null,
  														id: 327,
  														name: "k",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 305,
  														src: "2894:1:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "2883:13:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "2876:21:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "2863:34:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 342,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 331,
  													name: "supplyValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 300,
  													src: "2912:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 339,
  																	name: "price",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 324,
  																	src: "2978:5:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	argumentTypes: null,
  																	"arguments": [
  																		{
  																			argumentTypes: null,
  																			id: 336,
  																			name: "account",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 297,
  																			src: "2965:7:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		}
  																	],
  																	expression: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: null,
  																			id: 334,
  																			name: "market",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 316,
  																			src: "2942:6:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_contract$_MarketInterface_$1824",
  																				typeString: "contract MarketInterface"
  																			}
  																		},
  																		id: 335,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "updatedSupplyOf",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: 1804,
  																		src: "2942:22:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  																			typeString: "function (address) view external returns (uint256)"
  																		}
  																	},
  																	id: 337,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	kind: "functionCall",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "2942:31:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 338,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "mul",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 2110,
  																src: "2942:35:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 340,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "2942:42:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 332,
  															name: "supplyValue",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 300,
  															src: "2926:11:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 333,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2168,
  														src: "2926:15:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 341,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "2926:59:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "2912:73:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 343,
  											nodeType: "ExpressionStatement",
  											src: "2912:73:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 355,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 344,
  													name: "borrowValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 302,
  													src: "2999:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 352,
  																	name: "price",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 324,
  																	src: "3065:5:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	argumentTypes: null,
  																	"arguments": [
  																		{
  																			argumentTypes: null,
  																			id: 349,
  																			name: "account",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 297,
  																			src: "3052:7:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		}
  																	],
  																	expression: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: null,
  																			id: 347,
  																			name: "market",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 316,
  																			src: "3029:6:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_contract$_MarketInterface_$1824",
  																				typeString: "contract MarketInterface"
  																			}
  																		},
  																		id: 348,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "updatedBorrowBy",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: 1811,
  																		src: "3029:22:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  																			typeString: "function (address) view external returns (uint256)"
  																		}
  																	},
  																	id: 350,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	kind: "functionCall",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "3029:31:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 351,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "mul",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 2110,
  																src: "3029:35:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 353,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "3029:42:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 345,
  															name: "borrowValue",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 302,
  															src: "3013:11:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 346,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2168,
  														src: "3013:15:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 354,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "3013:59:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "2999:73:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 356,
  											nodeType: "ExpressionStatement",
  											src: "2999:73:0"
  										}
  									]
  								},
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 311,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 308,
  										name: "k",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 305,
  										src: "2752:1:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 309,
  											name: "marketList",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 23,
  											src: "2756:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_array$_t_address_$dyn_storage",
  												typeString: "address[] storage ref"
  											}
  										},
  										id: 310,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "length",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "2756:17:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2752:21:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 358,
  								initializationExpression: {
  									assignments: [
  										305
  									],
  									declarations: [
  										{
  											constant: false,
  											id: 305,
  											name: "k",
  											nodeType: "VariableDeclaration",
  											scope: 358,
  											src: "2740:6:0",
  											stateVariable: false,
  											storageLocation: "default",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											typeName: {
  												id: 304,
  												name: "uint",
  												nodeType: "ElementaryTypeName",
  												src: "2740:4:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											value: null,
  											visibility: "internal"
  										}
  									],
  									id: 307,
  									initialValue: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 306,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2749:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									nodeType: "VariableDeclarationStatement",
  									src: "2740:10:0"
  								},
  								loopExpression: {
  									expression: {
  										argumentTypes: null,
  										id: 313,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "UnaryOperation",
  										operator: "++",
  										prefix: false,
  										src: "2775:3:0",
  										subExpression: {
  											argumentTypes: null,
  											id: 312,
  											name: "k",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 305,
  											src: "2775:1:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 314,
  									nodeType: "ExpressionStatement",
  									src: "2775:3:0"
  								},
  								nodeType: "ForStatement",
  								src: "2735:348:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 360,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getAccountValues",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 298,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 297,
  								name: "account",
  								nodeType: "VariableDeclaration",
  								scope: 360,
  								src: "2651:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 296,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "2651:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2650:17:0"
  					},
  					returnParameters: {
  						id: 303,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 300,
  								name: "supplyValue",
  								nodeType: "VariableDeclaration",
  								scope: 360,
  								src: "2689:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 299,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2689:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 302,
  								name: "borrowValue",
  								nodeType: "VariableDeclaration",
  								scope: 360,
  								src: "2707:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 301,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2707:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2688:36:0"
  					},
  					scope: 479,
  					src: "2625:464:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 477,
  						nodeType: "Block",
  						src: "3260:820:0",
  						statements: [
  							{
  								assignments: [
  									376
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 376,
  										name: "price",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3270:10:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 375,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3270:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 381,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 377,
  										name: "prices",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 20,
  										src: "3283:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  											typeString: "mapping(address => uint256)"
  										}
  									},
  									id: 380,
  									indexExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 378,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2431,
  											src: "3290:3:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 379,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "3290:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "3283:18:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3270:31:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 385,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 383,
  												name: "price",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 376,
  												src: "3319:5:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 384,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3327:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "3319:9:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 382,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "3311:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 386,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3311:18:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 387,
  								nodeType: "ExpressionStatement",
  								src: "3311:18:0"
  							},
  							{
  								assignments: [
  									389
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 389,
  										name: "collateralPrice",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3340:20:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 388,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3340:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 395,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 390,
  										name: "prices",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 20,
  										src: "3363:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  											typeString: "mapping(address => uint256)"
  										}
  									},
  									id: 394,
  									indexExpression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 392,
  												name: "collateralMarket",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 368,
  												src: "3378:16:0",
  												typeDescriptions: {
  													typeIdentifier: "t_contract$_MarketInterface_$1824",
  													typeString: "contract MarketInterface"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_contract$_MarketInterface_$1824",
  													typeString: "contract MarketInterface"
  												}
  											],
  											id: 391,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											lValueRequested: false,
  											nodeType: "ElementaryTypeNameExpression",
  											src: "3370:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_type$_t_address_$",
  												typeString: "type(address)"
  											},
  											typeName: "address"
  										},
  										id: 393,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "typeConversion",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3370:25:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "3363:33:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3340:56:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 399,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 397,
  												name: "collateralPrice",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 389,
  												src: "3414:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 398,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3432:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "3414:19:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 396,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "3406:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 400,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3406:28:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 401,
  								nodeType: "ExpressionStatement",
  								src: "3406:28:0"
  							},
  							{
  								assignments: [
  									403
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 403,
  										name: "supplyValue",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3445:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 402,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3445:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 404,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3445:16:0"
  							},
  							{
  								assignments: [
  									406
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 406,
  										name: "borrowValue",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3471:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 405,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3471:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 407,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3471:16:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 414,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 408,
  												name: "supplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 403,
  												src: "3499:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 409,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 406,
  												src: "3512:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 410,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "3498:26:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 412,
  												name: "borrower",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 362,
  												src: "3544:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 411,
  											name: "getAccountValues",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 360,
  											src: "3527:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address) view returns (uint256,uint256)"
  											}
  										},
  										id: 413,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3527:26:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "3498:55:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 415,
  								nodeType: "ExpressionStatement",
  								src: "3498:55:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 419,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 417,
  												name: "borrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 406,
  												src: "3571:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 418,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3585:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "3571:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 416,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "3563:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 420,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3563:24:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 421,
  								nodeType: "ExpressionStatement",
  								src: "3563:24:0"
  							},
  							{
  								assignments: [
  									423
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 423,
  										name: "healthIndex",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3598:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 422,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3598:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 428,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 425,
  											name: "supplyValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 403,
  											src: "3638:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 426,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 406,
  											src: "3651:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 424,
  										name: "calculateHealthIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 295,
  										src: "3617:20:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 427,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3617:46:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3598:65:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 432,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 430,
  												name: "healthIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 423,
  												src: "3682:11:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "<=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 431,
  												name: "MANTISSA",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 30,
  												src: "3697:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "3682:23:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 429,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "3674:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 433,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3674:32:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 434,
  								nodeType: "ExpressionStatement",
  								src: "3674:32:0"
  							},
  							{
  								assignments: [
  									436
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 436,
  										name: "liquidationValue",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3717:21:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 435,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3717:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 441,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 439,
  											name: "price",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 376,
  											src: "3752:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 437,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 366,
  											src: "3741:6:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 438,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "mul",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2110,
  										src: "3741:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 440,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3741:17:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3717:41:0"
  							},
  							{
  								assignments: [
  									443
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 443,
  										name: "liquidationPercentage",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3768:26:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 442,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3768:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 451,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 449,
  											name: "borrowValue",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 406,
  											src: "3832:11:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 446,
  													name: "MANTISSA",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 30,
  													src: "3818:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 444,
  													name: "liquidationValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 436,
  													src: "3797:16:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 445,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "3797:20:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 447,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3797:30:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 448,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "3797:34:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 450,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3797:47:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3768:76:0"
  							},
  							{
  								assignments: [
  									453
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 453,
  										name: "collateralValue",
  										nodeType: "VariableDeclaration",
  										scope: 477,
  										src: "3854:20:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 452,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3854:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 461,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 459,
  											name: "MANTISSA",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 30,
  											src: "3920:8:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 456,
  													name: "liquidationPercentage",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 443,
  													src: "3893:21:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 454,
  													name: "supplyValue",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 403,
  													src: "3877:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 455,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "3877:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 457,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3877:38:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 458,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "3877:42:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 460,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3877:52:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3854:75:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 467,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 462,
  										name: "collateralAmount",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 373,
  										src: "3940:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 465,
  												name: "collateralPrice",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 389,
  												src: "3979:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 463,
  												name: "collateralValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 453,
  												src: "3959:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 464,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "3959:19:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 466,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3959:36:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "3940:55:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 468,
  								nodeType: "ExpressionStatement",
  								src: "3940:55:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 472,
  											name: "borrower",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 362,
  											src: "4034:8:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 473,
  											name: "liquidator",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 364,
  											src: "4044:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 474,
  											name: "collateralAmount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 373,
  											src: "4056:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 469,
  											name: "collateralMarket",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 368,
  											src: "4006:16:0",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										},
  										id: 471,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "transferTo",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1823,
  										src: "4006:27:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256) external"
  										}
  									},
  									id: 475,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4006:67:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 476,
  								nodeType: "ExpressionStatement",
  								src: "4006:67:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 478,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 371,
  							modifierName: {
  								argumentTypes: null,
  								id: 370,
  								name: "onlyMarket",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 68,
  								src: "3216:10:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "3216:10:0"
  						}
  					],
  					name: "liquidateCollateral",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 369,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 362,
  								name: "borrower",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3124:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 361,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3124:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 364,
  								name: "liquidator",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3142:18:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 363,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3142:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 366,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3162:11:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 365,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3162:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 368,
  								name: "collateralMarket",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3175:32:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_contract$_MarketInterface_$1824",
  									typeString: "contract MarketInterface"
  								},
  								typeName: {
  									contractScope: null,
  									id: 367,
  									name: "MarketInterface",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1824,
  									src: "3175:15:0",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_MarketInterface_$1824",
  										typeString: "contract MarketInterface"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3123:85:0"
  					},
  					returnParameters: {
  						id: 374,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 373,
  								name: "collateralAmount",
  								nodeType: "VariableDeclaration",
  								scope: 478,
  								src: "3236:21:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 372,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3236:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3235:23:0"
  					},
  					scope: 479,
  					src: "3095:985:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				}
  			],
  			scope: 480,
  			src: "96:3986:0"
  		}
  	],
  	src: "0:4084:0"
  };
  var compiler = {
  	name: "solc",
  	version: "0.5.16+commit.9c3226ce.Emscripten.clang"
  };
  var networks = {
  };
  var schemaVersion = "3.2.4";
  var updatedAt = "2020-09-24T14:12:15.605Z";
  var devdoc = {
  	methods: {
  	}
  };
  var userdoc = {
  	methods: {
  	}
  };
  var ControllerContract = {
  	contractName: contractName,
  	abi: abi,
  	metadata: metadata,
  	bytecode: bytecode,
  	deployedBytecode: deployedBytecode,
  	sourceMap: sourceMap,
  	deployedSourceMap: deployedSourceMap,
  	source: source,
  	sourcePath: sourcePath,
  	ast: ast,
  	legacyAST: legacyAST,
  	compiler: compiler,
  	networks: networks,
  	schemaVersion: schemaVersion,
  	updatedAt: updatedAt,
  	devdoc: devdoc,
  	userdoc: userdoc
  };

  var Controller = function () {
    function Controller() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        1337: {
          httpProvider: 'http://127.0.0.1:8545',
          wsProvider: 'ws://127.0.0.1:8545'
        }
      };
      _classCallCheck__default['default'](this, Controller);
      this.instanceAddress = address.toLowerCase();
      if (!this.address.match(/0x[a-f0-9]{40}/)) return new Error('Missing address');
      this.instance = new rbankUtils.web3.eth.Contract(ControllerContract.abi, address);
      this.eventualWeb3WS = rbankUtils.getEventualChainId().then(function (chainId) {
        return new rbankUtils.Web3Utils(config[chainId].wsProvider);
      }).catch(function () {
        return new Error('Something went wrong with the web3 instance over web sockets on Controller');
      });
      this.eventualWeb3Http = rbankUtils.getEventualChainId().then(function (chainId) {
        return new rbankUtils.Web3Utils(config[chainId].httpProvider);
      }).catch(function () {
        return new Error('Something went wrong with the web3 instance over http on Controller');
      });
    }
    _createClass__default['default'](Controller, [{
      key: "getPastBlockNumbers",
      value: function getPastBlockNumbers(period) {
        var _this = this;
        var pastBlockNumbers = [];
        var blocksPerYear = 1000000;
        var labelsPerPeriod;
        var blocksPerPeriod;
        switch (period) {
          case rbankUtils.PERIOD_DAY:
            labelsPerPeriod = 12;
            blocksPerPeriod = Math.floor(blocksPerYear / (365.25 * 12));
            break;
          case rbankUtils.PERIOD_WEEK:
            labelsPerPeriod = 7;
            blocksPerPeriod = Math.floor(blocksPerYear / 365.25);
            break;
          case rbankUtils.PERIOD_MONTH:
            labelsPerPeriod = 15;
            blocksPerPeriod = Math.floor(blocksPerYear * 2 / 365.25);
            break;
          case rbankUtils.PERIOD_YEAR:
            labelsPerPeriod = 12;
            blocksPerPeriod = Math.floor(blocksPerYear / 12);
            break;
          default:
            labelsPerPeriod = 7;
            blocksPerPeriod = Math.floor(blocksPerYear / 365.25);
        }
        return new Promise(function (resolve, reject) {
          Promise.all([_this.eventualDeployBlock, rbankUtils.web3.eth.getBlockNumber()]).then(function (_ref) {
            var _ref2 = _slicedToArray__default['default'](_ref, 2),
                deployBlock = _ref2[0],
                currentBlockNumber = _ref2[1];
            ___default['default'].range(labelsPerPeriod).forEach(function (i) {
              var pastBlockNumber = currentBlockNumber - blocksPerPeriod * i >= deployBlock ? currentBlockNumber - blocksPerPeriod * i : deployBlock;
              pastBlockNumbers.push(pastBlockNumber);
            });
            resolve(pastBlockNumbers);
          }).catch(reject);
        });
      }
    }, {
      key: "getOverallBalance",
      value: function getOverallBalance(from) {
        var _this2 = this;
        var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : rbankUtils.PERIOD_WEEK;
        return new Promise(function (resolve, reject) {
          _this2.getPastBlockNumbers(period).then(function (pastBlockNumbers) {
            var pastAccountValuesPromises = Promise.all(pastBlockNumbers.map(function (blockNumber) {
              var controller = new Controller(_this2.address);
              controller.setDefaultBlock(blockNumber);
              return controller.getAccountValues(from);
            }));
            var pastBlocksPromise = Promise.all(pastBlockNumbers.map(function (blockNumber) {
              return rbankUtils.web3.eth.getBlock(blockNumber);
            }));
            return Promise.all([pastAccountValuesPromises, pastBlocksPromise]);
          }).then(function (_ref3) {
            var _ref4 = _slicedToArray__default['default'](_ref3, 2),
                pastAccountValues = _ref4[0],
                pastBlocks = _ref4[1];
            var overallBalances = pastAccountValues.map(function (_ref5, idx) {
              var supplyValue = _ref5.supplyValue,
                  borrowValue = _ref5.borrowValue;
              var balance = supplyValue - borrowValue;
              var time = new Date(pastBlocks[idx].timestamp * 1000);
              return [time, balance];
            });
            resolve(overallBalances);
          }).catch(reject);
        });
      }
    }, {
      key: "setDefaultBlock",
      value: function setDefaultBlock(blockNumber) {
        this.instance.defaultBlock = blockNumber;
      }
    }, {
      key: "setCollateralFactor",
      value: function setCollateralFactor(collateralFactor) {
        var _this3 = this;
        return new Promise(function (resolve, reject) {
          _this3.eventualMantissa.then(function (mantissa) {
            return rbankUtils.send(_this3.instance.methods.setCollateralFactor(collateralFactor * mantissa));
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "setLiquidationFactor",
      value: function setLiquidationFactor(liquidationFactor) {
        var _this4 = this;
        return new Promise(function (resolve, reject) {
          _this4.eventualMantissa.then(function (mantissa) {
            return rbankUtils.send(_this4.instance.methods.setLiquidationFactor(liquidationFactor * mantissa));
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "addMarket",
      value: function addMarket(marketAddress) {
        var _this5 = this;
        return new Promise(function (resolve, reject) {
          rbankUtils.send(_this5.instance.methods.addMarket(marketAddress)).then(resolve).catch(reject);
        });
      }
    }, {
      key: "setMarketPrice",
      value: function setMarketPrice(marketAddress, marketPrice) {
        var _this6 = this;
        return new Promise(function (resolve, reject) {
          rbankUtils.send(_this6.instance.methods.setPrice(marketAddress, marketPrice)).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualMarketPrice",
      value: function eventualMarketPrice(marketAddress) {
        var _this7 = this;
        return new Promise(function (resolve, reject) {
          _this7.instance.methods.prices(marketAddress).call().then(function (price) {
            return Number(price);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "getAccountValues",
      value: function getAccountValues(account) {
        var _this8 = this;
        return new Promise(function (resolve, reject) {
          _this8.instance.methods.getAccountValues(account).call().then(function (_ref6) {
            var supplyValue = _ref6.supplyValue,
                borrowValue = _ref6.borrowValue;
            return {
              supplyValue: Number(supplyValue),
              borrowValue: Number(borrowValue)
            };
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "getAccountLiquidity",
      value: function getAccountLiquidity(account) {
        var _this9 = this;
        return new Promise(function (resolve, reject) {
          _this9.instance.methods.getAccountLiquidity(account).call().then(function (liquidity) {
            return Number(liquidity);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "getAccountHealth",
      value: function getAccountHealth(account) {
        var _this10 = this;
        return new Promise(function (resolve, reject) {
          Promise.all([_this10.eventualMantissa, _this10.getAccountValues(account)]).then(function (_ref7) {
            var _ref8 = _slicedToArray__default['default'](_ref7, 2),
                mantissa = _ref8[0],
                borrowValue = _ref8[1].borrowValue;
            if (borrowValue <= 0) resolve(1);
            return Promise.all([mantissa, _this10.instance.methods.getAccountHealth(account).call()]);
          }).then(function (_ref9) {
            var _ref10 = _slicedToArray__default['default'](_ref9, 2),
                mantissa = _ref10[0],
                accountHealth = _ref10[1];
            return Number(accountHealth) / mantissa;
          }).then(function (accountHealth) {
            return 1 / (1 + Math.exp(-accountHealth));
          }).then(function (sigmoidHealth) {
            return (Number(sigmoidHealth) - 0.731059) / (0.999999 - 0.731059);
          }).then(function (healthPercentage) {
            return healthPercentage < 0 ? 0 : Number(healthPercentage.toFixed(6));
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "getEventualMarketAddress",
      value: function getEventualMarketAddress(marketIdx) {
        var _this11 = this;
        return new Promise(function (resolve, reject) {
          _this11.instance.methods.marketList(marketIdx).call().then(resolve).catch(reject);
        });
      }
    }, {
      key: "getEventualMarketAddressByToken",
      value: function getEventualMarketAddressByToken(tokenAddress) {
        var _this12 = this;
        return new Promise(function (resolve, reject) {
          _this12.instance.methods.marketsByToken(tokenAddress).call().then(function (marketAddress) {
            if (marketAddress.match(/0x[0]{40}/)) throw new Error('Token address not registered');
            return marketAddress;
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualIsOwner",
      value: function eventualIsOwner() {
        var _this13 = this;
        var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return new Promise(function (resolve, reject) {
          rbankUtils.web3.eth.getAccounts().then(function (_ref11) {
            var _ref12 = _slicedToArray__default['default'](_ref11, 1),
                account = _ref12[0];
            return [account, _this13.instance.methods.owner().call()];
          }).then(function (results) {
            return Promise.all(results);
          }).then(function (_ref13) {
            var _ref14 = _slicedToArray__default['default'](_ref13, 2),
                account = _ref14[0],
                registeredOwner = _ref14[1];
            if (from) {
              return from === registeredOwner;
            }
            return account === registeredOwner;
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "address",
      get: function get() {
        return this.instanceAddress;
      }
    }, {
      key: "eventualDeployBlock",
      get: function get() {
        var _this14 = this;
        return new Promise(function (resolve, reject) {
          _this14.instance.methods.deployBlock().call().then(function (block) {
            return Number(block);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualCollateralFactor",
      get: function get() {
        var _this15 = this;
        return new Promise(function (resolve, reject) {
          _this15.eventualMantissa.then(function (mantissa) {
            return [mantissa, _this15.instance.methods.collateralFactor().call()];
          }).then(function (promises) {
            return Promise.all(promises);
          }).then(function (_ref15) {
            var _ref16 = _slicedToArray__default['default'](_ref15, 2),
                mantissa = _ref16[0],
                collateralFactor = _ref16[1];
            return Number(collateralFactor / mantissa);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualLiquidationFactor",
      get: function get() {
        var _this16 = this;
        return new Promise(function (resolve, reject) {
          _this16.eventualMantissa.then(function (mantissa) {
            return [mantissa, _this16.instance.methods.liquidationFactor().call()];
          }).then(function (promises) {
            return Promise.all(promises);
          }).then(function (_ref17) {
            var _ref18 = _slicedToArray__default['default'](_ref17, 2),
                mantissa = _ref18[0],
                liquidationFactor = _ref18[1];
            return Number(liquidationFactor / mantissa);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualMarketListSize",
      get: function get() {
        var _this17 = this;
        return new Promise(function (resolve, reject) {
          _this17.instance.methods.marketListSize().call().then(function (marketListSize) {
            return Number(marketListSize);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualOwner",
      get: function get() {
        var _this18 = this;
        return new Promise(function (resolve, reject) {
          _this18.instance.methods.owner().call().then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualMantissa",
      get: function get() {
        var _this19 = this;
        return new Promise(function (resolve, reject) {
          _this19.instance.methods.MANTISSA().call().then(function (mantissa) {
            return Number(mantissa);
          }).then(resolve).catch(reject);
        });
      }
    }], [{
      key: "create",
      value: function create() {
        return new Promise(function (resolve, reject) {
          var controller = new rbankUtils.web3.eth.Contract(ControllerContract.abi);
          var deploy = controller.deploy({
            data: ControllerContract.bytecode
          });
          rbankUtils.web3.eth.getAccounts().then(function (_ref19) {
            var _ref20 = _slicedToArray__default['default'](_ref19, 1),
                from = _ref20[0];
            return [from, deploy.estimateGas({
              from: from
            })];
          }).then(function (result) {
            return Promise.all(result);
          }).then(function (_ref21) {
            var _ref22 = _slicedToArray__default['default'](_ref21, 2),
                from = _ref22[0],
                gas = _ref22[1];
            return deploy.send({
              from: from,
              gas: gas
            });
          })
          .then(function (instance) {
            return instance._address.toLowerCase();
          }).then(resolve).catch(reject);
        });
      }
    }]);
    return Controller;
  }();

  return Controller;

})));
